import React from "react";
import CustomerItemEquivalencesPageGen from "./generated/CustomerItemEquivalencesPageGen";
import customerItemEquivalencesService from "../../../services/legacy/customerItemEquivalencesService";

const SHOW_IN_GRID = new Set(["dataAreaId", "custaccount", "customeritemcode", "itemId", "hitcount", "isactive", "modifieddate"]);
const SHOW_IN_FILTER = new Set(["custaccount", "customeritemcode", "itemId", "sourcepurchorderformnum"]);

const transformColumns = (baseColumns) => {
  return baseColumns.map((column) => ({
    ...column,
    showInGrid: SHOW_IN_GRID.has(column.key),
    showInFilter: SHOW_IN_FILTER.has(column.key),
  }));
};

const CustomerItemEquivalencesPage = () => {
  const service = customerItemEquivalencesService;
  return <CustomerItemEquivalencesPageGen service={service} transformColumns={transformColumns} />;
};

export default CustomerItemEquivalencesPage;